
<div>
    <div class="grid grid-cols-1 mb-4">
        <spike-field-wrapper label="Cerca" labelFor="omnisearch_equipmentrequestfilters" >
            <input id="omnisearch_equipmentrequestfilters" placeholder="Cerca per codice, titolo, cliente etc.." pInputText [ngModel]="searchFilter().omnisearch" (ngModelChange)="updateFilter('omnisearch', $event)" class="w-full"/>
        </spike-field-wrapper>
    </div>
    <div class="flex " style="align-items:center">
        @for (item of workflowState; track $index) {
            <div class="mr-2">
                <p-button [label]="item.label" [severity]="searchFilter().stateId == item.id ? 'info' : 'secondary'" styleClass="m-0" size="small" (click)="searchByState(item.id)" />
            </div>
        }
    </div>
</div>
